import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const MUTATION = gql`
  mutation updateCustomerState(
    $site: String!
    $customerId: String!
    $key: String!
    $value: Boolean!
  ) {
    updateCustomerState(
      site: $site
      customerId: $customerId
      key: $key
      value: $value
    ) {
      id
    }
  }
`;

const useUpdateCustomerState = (onCompleted = () => {}) => {
  const [action] = useMutation(MUTATION, { onCompleted });

  return (site: string, customerId: string, key: string, value: boolean) => {
    return action({ variables: { site, customerId, key, value } });
  };
};

export default useUpdateCustomerState;
